import { BREAD_MODIFICATION_GROUP_DISPLAY_NAME } from '../../customization.machine.constants';
import {
  type Modification,
  type ModificationsMap,
  type Modifier,
  type Modifiers,
} from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getModifiersCount(
  modifiers: Modifiers,
  allModificationsMap: ModificationsMap,
): number {
  const { additions, removals, substitutions } = modifiers;

  const checkIfShouldIncludeModifier = checkIfShouldIncludeModifierFactory(allModificationsMap);

  const filteredAdditions = additions.filter(checkIfShouldIncludeModifier);
  const filteredRemovals = removals.filter(checkIfShouldIncludeModifier);

  return filteredAdditions.length + filteredRemovals.length + substitutions.length;
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfShouldIncludeModifierFactory(allModificationsMap: ModificationsMap) {
  return (modifier: Modifier): boolean => {
    const modification = allModificationsMap.get(modifier.ingredientId);

    if (!modification) {
      return true;
    }

    const shouldExclude = checkIfBreadModifier(modification);

    return !shouldExclude;
  };
}

export function checkIfBreadModifier(modification: Modification) {
  const { modificationGroupDisplayName } = modification;
  const formattedGroupName = modificationGroupDisplayName.toLocaleLowerCase();

  return formattedGroupName.includes(BREAD_MODIFICATION_GROUP_DISPLAY_NAME);
}
